import type { ReactNode } from 'react';
import styles from './AccessBadge.module.css';

type AccessBadgeProps = {
  children: ReactNode;
  variant?: 'free' | 'premium' | 'trial';
  size?: 'default' | 'sm';
};

export default function AccessBadge({ children, variant = 'free', size = 'default' }: AccessBadgeProps) {
  const classes = [
    styles.badge,
    variant === 'premium' ? styles.badgePremium : '',
    variant === 'trial' ? styles.badgeTrial : '',
    size === 'sm' ? styles.badgeSm : '',
  ].filter(Boolean).join(' ');
  return <span className={classes}>{children}</span>;
}
